import i18n from 'i18next'
import { DateTime } from 'luxon'

export const months = () =>
  Array.from({ length: 12 }, (_, i) => ({
    label: DateTime.local()
      .setLocale(i18n.language || 'en')
      .set({ month: i + 1 })
      .toFormat('MMMM'),
    value: i + 1,
  }))

export const days = Array.from({ length: 31 }, (_, i) => ({
  label: (i + 1).toString(),
  value: i + 1,
}))

const currentYear = DateTime.local().year - 18
export const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => ({
  label: (currentYear - i).toString(),
  value: currentYear - i,
}))
